import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionnaire = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "questionnaire-icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .secc6 {\n        fill: #0573A9;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "secc6",
			d: "M12.0459,4.86639L7.6792.49921c-.29053-.28955-.67725-.44922-1.08838-.44922h-3.05176C2.41748.04999,1.50537.96259,1.50537,2.08417v9.88965c0,1.12207.91211,2.03418,2.03369,2.03418h6.92188c1.12207,0,2.03418-.91211,2.03418-2.03418v-6.01904c0-.41016-.15918-.7959-.44922-1.08838ZM10.61969,4.9953h-2.63092c-.2417,0-.43896-.19727-.43896-.43945V1.92505l3.06989,3.07025ZM10.46094,12.90839H3.53906c-.51514,0-.93408-.41895-.93408-.93457V2.08417c0-.51514.41895-.93457.93408-.93457h2.91113v3.40625c0,.84863.68994,1.53906,1.53857,1.53906h3.40674v5.87891c0,.51562-.41895.93457-.93457.93457Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc6",
			d: "M3.95557,6.81561h-.00977c-.33154,0-.59521.26855-.59521.6001s.27393.6001.60498.6001c.33154,0,.6001-.26855.6001-.6001s-.26855-.6001-.6001-.6001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc6",
			d: "M10.08301,6.81561h-4.28516c-.33154,0-.6001.26855-.6001.6001s.26855.6001.6001.6001h4.28516c.33105,0,.59961-.26855.59961-.6001s-.26855-.6001-.59961-.6001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc6",
			d: "M10.08301,8.8161h-4.28516c-.33154,0-.6001.26904-.6001.6001s.26855.59961.6001.59961h4.28516c.33105,0,.59961-.26855.59961-.59961s-.26855-.6001-.59961-.6001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc6",
			d: "M3.95557,8.8161h-.00977c-.33154,0-.59521.26904-.59521.6001s.27393.59961.60498.59961c.33154,0,.6001-.26855.6001-.59961s-.26855-.6001-.6001-.6001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc6",
			d: "M10.08301,10.81659h-4.28516c-.33154,0-.6001.26855-.6001.59961s.26855.59961.6001.59961h4.28516c.33105,0,.59961-.26855.59961-.59961s-.26855-.59961-.59961-.59961Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc6",
			d: "M3.95557,10.81659h-.00977c-.33154,0-.59521.26855-.59521.59961s.27393.59961.60498.59961c.33154,0,.6001-.26855.6001-.59961s-.26855-.59961-.6001-.59961Z"
		})
	]
});
export default SvgQuestionnaire;
